import { Component, OnInit } from '@angular/core';
import { IonRouterOutlet, ModalController, NavParams, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { MatchService } from 'src/app/services/match.service';
import { UserService } from '@shared/services/user.service';
import { PicturesPage } from '../pictures/pictures.page';
import { ChatPage } from '../chat/chat.page';
import { LoginPage } from '../login/login.page';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-veg-match',
  templateUrl: './veg-match.page.html',
  styleUrls: ['./veg-match.page.scss'],
  providers: [UserService, MatchService, TranslateService, IonRouterOutlet]
})
export class VegMatchPage implements OnInit {
  public userData : any;  //main user's info
  public likedSoul : any; //matched user's info
  public pictures:any = [];   //where match's pictures will be stored
  public backButton: Subscription|any;
  constructor(
    public navParams: NavParams, 
    private router: Router,
    public translate : TranslateService,
    public matchService: MatchService,
    public platform: Platform,
    public modalCtrl: ModalController,
    private userService: UserService) {

      //this.userData = this.navParams.get('me');
      this.userData = this.navParams.get('me');
      this.likedSoul = this.navParams.get('otherSoul');
      this.loadUserPicture();
      //this.loadMyImages();

  }

  ionViewWillEnter() {
    if(this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        this.dismiss();
      }); 
    }
    console.log("this.userData vegmatch: ",this.userData);
    console.log("this.likedSoul vegmatch: ",this.likedSoul);

  }

  ionViewWillLeave() {
    if(this.backButton){
      this.backButton.unsubscribe();
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VegMatchPage');
  }

  ngOnInit() {
  }

  loadUserPicture() {
    this.userData.profilePic = PicturesPage.gray;// Set initially
    
    let i : number = 0;
    for(i=0; i<9; i++){
      const aPicName = 'picture' + i;
      const aPic = this.userData[aPicName];
      if(aPic != null){
        this.userData.profilePic = this.userService.getImageURL(aPic.$oid);
        break;
      }
    }
  }

  async chat(soulToChat : any){
    let modal = this.modalCtrl.create({component: ChatPage, componentProps: {me: this.userData, otherSoul : soulToChat}, showBackdrop:true});
    
    (await modal).onDidDismiss().then((val) => {
      console.log('Data returned from chat modal: ' + JSON.stringify(val.data))
      
      if (val && val.data === "logout") {
        this.router.navigateByUrl('/login');
      }

      if (val && val.data === "shouldRefreshList") {
        this.matchService.loadMatches(false);
      }

      if(val.data != null) {
        //do nothing
      }
    });

    (await modal).present();
  }

  dismiss(){
    this.modalCtrl.dismiss(null);
  }

}
